import { getToken, getRefreshToken, setToken, deleteToken } from "@/utils";
import { apiLoadingStates } from "@/utils/variables.js";

import auth from "@/services/auth";

const initialState = () => ({
  token: getToken() ? true : false,

  // errors
  errors: false,

  // loading state
  loadingState: apiLoadingStates.SUCCESS,
  signupApiStatus: apiLoadingStates.DEFAULT,
  signupErrors: null,

  // 1 - Loading, 2 - Successful, 3 - unsuccesful, 4 - uncaught error
  // password reset request
  sendEmailStatus: 0,
  sendEmailMessage: null,
  // passwordToken: localStorage.getItem("passwordToken") || null,

  // set new password
  setNewPasswordStatus: 0,
  setNewPasswordMessage: null,

  // logout
  logoutStatus: 0,
  logoutMessage: null,
});

const state = initialState();

const getters = {
  getErrors(state) {
    return state.errors;
  },
  getSignupErrors(state) {
    return state.signupErrors;
  },
  getLoadingStatus(state) {
    return state.loadingState;
  },
  getSignupApiStatus(state) {
    return state.signupApiStatus;
  },

  // password reset request
  sendEmailStatus: state => state.sendEmailStatus,
  sendEmailMessage: state => state.sendEmailMessage,
  // passwordToken: state => state.passwordToken,

  // set new password
  setNewPasswordStatus: state => state.setNewPasswordStatus,
  setNewPasswordMessage: state => state.setNewPasswordMessage,

  // logout
  logoutStatus: state => state.logoutStatus,
  logoutMessage: state => state.logoutMessage,
};

const actions = {
  login: async ({ commit }, payload) => {
    try {
      commit("setLoadingState", apiLoadingStates.LOADING);

      const response = await auth.login(payload);
      const token = response.data.data;
      commit("setToken", token);

      commit("setLoadingState", apiLoadingStates.SUCCESS);
    } catch (error) {
      window.e = error;
      const data = error.response.data;
      commit("setErrors", data.message);

      commit("setLoadingState", apiLoadingStates.ERROR);
    }
  },
  signup: async ({ commit }, payload) => {
    try {
      commit("setSignupApiStatus", apiLoadingStates.LOADING);

      await auth.signup(payload);

      commit("setSignupApiStatus", apiLoadingStates.SUCCESS);
    } catch (e) {
      window.e = error;
      // let errMsg = '';

      // if (!error.response) {
      //   // if (error.code === 'ECONNABORTED') {
      //   // }
      //   errMsg = 'We\'re having trouble communication with the servers. Are you connected?'
      // }
      // else errMsg = error.response.data.message;
      const error = e.response.data

      console.log('Err Message: ', error.message)
      commit("signupErrors", error);
    }
  },
  
  sendEmail: async ({ commit }, payload) => {
    try {
      commit("sendEmailRequest");
      const response = await auth.sendEmail(payload);
      commit("sendEmailSuccess", response.data);
    } catch (error) {
      // TODO: format all axios error messages accordingly (to be user friendly)
      commit("sendEmailError", error);
    }
  },
  setNewPassword: async ({ commit }, payload) => {
    try {
      commit("setNewPasswordRequest");
      const response = await auth.setNewPassword(payload);
      commit("setNewPasswordSuccess", response.data);
    } catch (error) {
      commit("setNewPasswordError", error);
    }
  },
  logout: async ({ commit }) => {
    const refreshToken = getRefreshToken();
    try {
      commit("logoutRequest");
      const response = await auth.logout({ token: refreshToken });
      commit("logoutSuccess", response.data);
      // commit("reset");
      // commit("Credentials/reset", null, { root: true });
      // commit("User/reset", null, { root: true });
    } catch (error) {
      commit("logoutError", error);
    }
  }
};

const mutations = {
  setToken(state, data) {
    state.token = true;
    setToken(data);
  },
  setErrors(state, data) {
    state.errors = data;
  },
  signupErrors(state, data) {
    state.signupErrors = data;
    state.signupApiStatus = apiLoadingStates.ERROR
  },
  setLoadingState(state, data) {
    state.loadingState = data;
  },
  setSignupApiStatus(state, data) {
    state.signupApiStatus = data;
  },

  // password reset request
  sendEmailDefault: state => (state.sendEmailStatus = 0),
  sendEmailRequest: state => (state.sendEmailStatus = 1),
  // eslint-disable-next-line no-unused-vars
  sendEmailSuccess(state, { message, data }) {
    // localStorage.setItem("passwordToken", data.token);
    state.sendEmailStatus = 2;
    state.sendEmailMessage = message;
  },
  sendEmailError(state, error) {
    state.sendEmailStatus = 3;
    state.sendEmailMessage = error.response.data.message;
  },

  // set new password
  setNewPasswordDefault: state => (state.setNewPasswordStatus = 0),
  setNewPasswordRequest: state => (state.setNewPasswordStatus = 1),
  setNewPasswordSuccess(state, { message }) {
    state.setNewPasswordStatus = 2;
    state.setNewPasswordMessage = message;
  },
  setNewPasswordError(state, error) {
    state.setNewPasswordStatus = 3;
    state.setNewPasswordMessage = error.response.data.message;
  },

  // logout
  logoutRequest: state => state.logoutStatus = 1,
  logoutSuccess(state, { message }) {
    state.logoutStatus = 2;
    state.logoutMessage = message;
  },
  logoutError(state, error) {
    state.logoutStatus = 3;
    state.logoutMessage = error.response.data.message;
  },

  // Reset
  reset(state) {
    deleteToken();
    const originalState = initialState();
    Object.keys(originalState).forEach(key => {
      state[key] = originalState[key];
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
